module.exports = __webpack_public_path__ + "static/img/logo_1.1769678785359.png";